import { toast } from "react-toastify";
import { base_url } from "./utils";


export const update_queries = async(body,)=>{
  try {
    const response = await fetch(base_url + "contact_us.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();

    if (res.success) {
      toast.success(res.message);
      return res;
    } else {
      toast.error(res.message);
      return res;
    }
  } catch (error) {
    console.log("error ==", error);

  }
}


export const add_testimonial = async (body, setLoading) => {
  try {
    setLoading && setLoading(true);
    const response = await fetch(base_url + "testimonial.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();

    setLoading && setLoading(false);
    if (res.success) {
      toast.success(res.message);
      return res;
    } else {
      toast.error(res.message);
      return res;
    }
  } catch (error) {
    console.log("error ==", error);

    setLoading && setLoading(false);
  }
};

export const add_blog = async (body, setLoading) => {
  try {
    setLoading && setLoading(true);
    const response = await fetch(base_url + "blog.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();

    setLoading && setLoading(false);
    if (res.success) {
      toast.success(res.message);
      return res;
    } else {
      toast.error(res.message);
      return res;
    }
  } catch (error) {
    console.log("error ==", error);

    setLoading && setLoading(false);
  }
};

export const add_media = async (body) => {
  try {
    const response = await fetch(base_url + "media.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    if (res.success) {
      toast.success(res.message);
      return res;
    } else {
      toast.error(res.message);
      return res;
    }
  } catch (error) {
    console.log("error ==", error);
  }
};

export const add_careers = async (body) => {
  try {
    const response = await fetch(base_url + "careers.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    if (res.success) {
      toast.success(res.message);
      return res;
    } else {
      toast.error(res.message);
      return res;
    }
  } catch (error) {
    console.log("error ==", error);
  }
};

export const add_associate = async (body) => {
  try {
    const response = await fetch(base_url + "associate_companies.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();

    
    if (res.success) {
      toast.success(res.message);
      return res;
    } else {
      toast.error(res.message);
      return res;
    }
  } catch (error) {
    console.log("error ==", error);
  }
};

const big_files_url = `${process.env.REACT_APP_BASE_URL || "https://dev.websiteadmin.insugo.in"}/api/large_files.php`;

export const upload_big_file = async (body, setLoading) => {
  try {
    setLoading && setLoading(true);
    const response = await fetch(big_files_url, { method: "POST", body });
    const res = await response.json();
    setLoading && setLoading(false);
    if (res.success) {
      toast.success(res.message || "File uploaded successfully");
      return res;
    } else {
      toast.error(res.message || "Upload failed");
      return res;
    }
  } catch (error) {
    setLoading && setLoading(false);
    toast.error("Something went wrong");
    console.log("error ==", error);
  }
};

export const fetch_big_files = async () => {
  const loggedInUser = localStorage.getItem("userId");
  const user = loggedInUser ? JSON.parse(loggedInUser) : null;
  try {
    const body = new FormData();
    body.append("action", "list");
    body.append("userid", user?.userid || "");
    const response = await fetch(big_files_url, { method: "POST", body });
    const res = await response.json();
    return res;
  } catch (error) {
    console.log("error ==", error);
    return null;
  }
};

export const login_api = async (body, setLoading) => {
  try {
    setLoading(true);
    const response = await fetch(base_url + "adminlogin.php", {
      method: "POST",
      body: body,
    });
    const res = await response.json();
    setLoading(false);
    if (res.success) {
      toast.success(res.message);
      localStorage.setItem("digiUserId", JSON.stringify(res));
      // window.location.reload();
      return res;
    } else {
      toast.error(res.message);
      return res;
    }
  } catch (error) {
    setLoading(false);
  }
};


